module.exports = __webpack_public_path__ + "static/media/Gallery_4-min.9372a145.jpg";